var _AnimatedStaticCoinRi;
import { useCallback } from 'react';
import { LazyImage } from '@crehana/compass.ui';
import cn from 'clsx';
import { AnimatedStaticCoinRive } from "../../../AnimatedStaticCoinRive";
import { humanizeISODate } from "../../../utils";
import { usePlayroomRewardsTranslations } from "../../hooks";
import RewardRequestedCardTag from "./components/RewardRequestedCardTag";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RewardRequestedCard = function RewardRequestedCard(_ref) {
  var title = _ref.title,
    deliveryId = _ref.deliveryId,
    coins = _ref.coins,
    status = _ref.status,
    imageSrc = _ref.imageSrc,
    createdAt = _ref.createdAt,
    className = _ref.className;
  var _usePlayroomRewardsTr = usePlayroomRewardsTranslations(),
    t = _usePlayroomRewardsTr.t,
    languageCode = _usePlayroomRewardsTr.languageCode;
  var historyDate = humanizeISODate(createdAt, languageCode);
  var renderStatus = useCallback(function () {
    switch (status) {
      case 'DELIVERED':
        return /*#__PURE__*/_jsx(RewardRequestedCardTag, {
          color: "SUCCESS",
          label: t('PRS_STATUS_DELIVERED')
        });
      case 'REJECTED':
        return /*#__PURE__*/_jsx(RewardRequestedCardTag, {
          color: "ALERT",
          label: t('PRS_STATUS_DELIVERED')
        });
      default:
        return /*#__PURE__*/_jsx(RewardRequestedCardTag, {
          color: "WARN",
          label: t('PRS_STATUS_REQUESTED')
        });
    }
  }, [status, t]);
  return /*#__PURE__*/_jsxs("article", {
    className: cn('tw-flex tw-justify-between tw-items-center tw-p-1.2', className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-flex",
      children: [/*#__PURE__*/_jsx(LazyImage, {
        src: imageSrc,
        alt: title,
        className: "tw-object-cover tw-w-7.2 tw-h-6.4 tw-overflow-hidden tw-rounded-0.4"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-ml-1.2",
        children: [/*#__PURE__*/_jsx("h4", {
          className: "tw-font-subtitle4 tw-mb-0.4 tw-line-clamp-1",
          children: title
        }), !!deliveryId && /*#__PURE__*/_jsx("p", {
          className: "tw-font-body4 tw-text-neutral-light-700 tw-mb-0.4",
          children: t('PRS_ORDER_NUMBER', {
            interpolation: {
              order: deliveryId
            }
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-flex tw-items-center tw-text-primary-light-500 dark:tw-text-primary-dark-300",
          children: [_AnimatedStaticCoinRi || (_AnimatedStaticCoinRi = /*#__PURE__*/_jsx(AnimatedStaticCoinRive, {})), /*#__PURE__*/_jsx("span", {
            className: "tw-font-subtitle3 tw-text-warning-500 tw-ml-0.4",
            children: coins
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-font-caption tw-mb-1.2",
        children: renderStatus()
      }), historyDate && /*#__PURE__*/_jsx("div", {
        className: "tw-font-label1 tw-text-neutral-light-600 tw-uppercase tw-text-center",
        children: historyDate
      })]
    })]
  });
};
export default RewardRequestedCard;